<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-file" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{doc.subject}}</div>
            <div class="meta">{{doc.id_number}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <b-tag class="stat" v-if="personal"><i class="fas fa-user mr-1"></i>Personal</b-tag>
                <b-tag type="is-warning" class="stat" v-if="!visible"><i class="fas fa-eye-slash mr-1"></i>Staff</b-tag>
            </div>
        </template>
        <template v-slot:details>
            <div class="details-rollout">
                <div class="data mt-3">
                    <data-row mini title="Created">{{doc.created_at | moment('MM/DD/YYYY')}}</data-row>
                    <data-row mini title="ID">{{doc.id}}</data-row>
                    <data-row mini title="In Navigator">{{visible ? 'Everyone' : 'Staff only'}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "../TIER/components/Toolbar";
    import DataRow from "../TIER/components/DataRow";
    import CardListItem from "../TIER/components/CardListItem";

    export default {
        name: 'DocumentListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            doc: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            // Marks a document added for one participant rather than the whole trip.
            personal: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false
            }
        },
        computed: {
            // Documents left out of Navigator are still shown there to staff
            // registrations, the same way vendor information is.
            visible: function () {
                return !!Number(this.doc.is_app_visible);
            }
        }
    }
</script>

<style lang="scss" scoped>

    li {
        color: darken($t-primary, 10);

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        padding: 0.5rem 0;

        .details-rollout {
            margin-top: 0.5rem;
        }
    }

    .drag-handle {
        cursor: ns-resize;
    }
</style>
